import React from "react";
import "./ProviderTierPriceTable.css";
import { elakayAutoText } from "../../pageInside/dataElakay";


const formatUsd = (value) =>
  (Number(value) || 0).toLocaleString("en-US", { style: "currency", currency: "USD" });

// spec §15 -- affiche les paliers de prix Provider (ProviderProduct.
// quantityPricing, déjà construit en Phase 3) EN LECTURE SEULE. Jamais
// modifiable par le Seller -- réutilisé tel quel entre ProviderProductDetail
// (View Product) et DropshippingInAddProduct (Add Product), une seule
// implémentation (spec §37 -- éviter les gros fichiers dupliqués).
const ProviderTierPriceTable = ({ tiers }) => {
  if (!tiers || tiers.length === 0) return null;

  return (
    <div className="dsi-tier-table">
      <table>
        <thead>
          <tr>
            <th>{elakayAutoText("h_44f6af6945544c", "Quantity")}</th>
            <th>{elakayAutoText("h_1eea68d093d156", "Unit Price")}</th>
          </tr>
        </thead>
        <tbody>
          {tiers.map((tier, index) => (
            <tr key={index}>
              <td>
                {tier.maxQuantity
                  ? `${tier.minQuantity}–${tier.maxQuantity}`
                  : `${tier.minQuantity}+`}
              </td>
              <td>
                {tier.discountPercent !== null && tier.discountPercent !== undefined
                  ? `${tier.discountPercent}% off`
                  : formatUsd(tier.unitPrice)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProviderTierPriceTable;
